import React from 'react';
import { Navigate } from 'react-router-dom';

import {
  CREATE_PACKAGE_SCRIPT_ID,
  CREATE_PRODUCT_OFFERINGS_SCRIPT_ID,
  UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID,
  UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID,
  UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID,
  UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID,
} from 'constants/constants';
import paths from './paths';

const buildUploadsPathForScript = (scriptId) =>
  `${paths.uploads}?scriptId=${scriptId}`;

export const legacyUploadRedirects = [
  { path: '/createPackage', scriptId: CREATE_PACKAGE_SCRIPT_ID },
  { path: '/createProductOfferings', scriptId: CREATE_PRODUCT_OFFERINGS_SCRIPT_ID },
  { path: '/uploadFeatureOfferings', scriptId: UPLOAD_FEATURE_OFFERINGS_TO_PACKAGES_SCRIPT_ID },
  { path: '/uploadPackageSchedule', scriptId: UPLOAD_PACKAGE_SCHEDULE_SCRIPT_ID },
  { path: '/updatePackageSchedule', scriptId: UPDATE_PACKAGE_SCHEDULE_SCRIPT_ID },
  { path: '/uploadOrUpdatePackagePaymentHead', scriptId: UPDATE_OR_UPLOAD_PACKAGE_PAYMENT_HEAD_SCRIPT_ID },
].map(({ path, scriptId }) => ({
  path,
  element: <Navigate to={buildUploadsPathForScript(scriptId)} replace />,
}));
